import React from 'react'
import { useQuery } from '~/client/hooks/cqrpc'

import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Box from '@mui/material/Box'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import AddCircleIcon from '@mui/icons-material/AddCircle';

import Link from '~/client/components/Link'
import ErrorMessage from '~/client/components/ErrorMessage'
import Timestamp from '~/client/components/Timestamp'
import Heading from '~/client/components/Heading'
import SideNote from '~/client/components/SideNote'

export default function DataPage() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return <Container>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Heading my={2} variant="main">Data</Heading>
    </Stack>
    <SideNote>
      Data is stored in your secure, on-line DataPal vault. It is divided into ‘Data Blocks’ that store 
      data on different aspects of your life: Contact Preferences, Car Details, Insurance Policies etc. 
      You can use as many of these blocks as you wish and can then share the data with connections that 
      you choose​.
    </SideNote>
    <Box sx={{ borderBottom: 1, borderColor: 'divider', my: 2, maxWidth: '75vw'}}>
      <Tabs value={value} onChange={handleChange}>
          <Tab label="My Data Blocks" {...allyProps(0)} />
          <Tab label="Available Templates" {...allyProps(1)} />
      </Tabs>
    </Box>
    <TabPanel value={value} index={0}>
      <MyDataList />
    </TabPanel>
    <TabPanel value={value} index={1}>
      <PublicTemplateList/>
    </TabPanel>
  </Container>
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function allyProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function MyDataList(){
  const query = useQuery('documents.getMine')
  const documents = query.result || []
  return <>
    <ErrorMessage error={query.error}/>
    <TableContainer sx={{maxWidth: '75vw'}}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>My Block's Name</TableCell>
            <TableCell>Template Used</TableCell>
            <TableCell align="right">Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{
          '&:last-child td, &:last-child th': {
            border: 0
          }
        }}>
          {documents.map(document =>
              <MyDataTableRow key={document.id} document={document}/>
            )
          }
        </TableBody>
      </Table>
    </TableContainer>
  </>
}

function MyDataTableRow({ document }){
  return <>
    <TableRow>
      <TableCell sx={{p: 1}}>
        <Link to={`/data/${document.id}`}>
           {document.name}
        </Link>
      </TableCell>
      <TableCell sx={{p: 1}}>
        {document.type.name}
      </TableCell>
      <TableCell sx={{p: 1, overflow: 'scroll'}} align="right">
        <Timestamp at={document.createdAt}/>
      </TableCell>
    </TableRow>
  </>
}

function PublicTemplateList(){
  const query = useQuery('documentTypes.getAllTemplates')
  const documentTypes = query.result || []
  console.log(documentTypes)
  return <>
    <ErrorMessage error={query.error}/>
    <TableContainer sx={{maxWidth: '75vw'}}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Template Name</TableCell>
            <TableCell>Template Category</TableCell>
            <TableCell align="right">Times Used</TableCell>
            <TableCell align="right">Add</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{
          '&:last-child td, &:last-child th': {
            border: 0
          }
        }}>
          {
            documentTypes.map(documentType =>
              <TemplateDataTableRow key={documentType.id} documentType={documentType}/>
            )
          }
        </TableBody>
      </Table>
    </TableContainer>
  </>
}

function TemplateDataTableRow({ documentType }){
  return <>
    <TableRow>
      <TableCell sx={{p: 1}}>
        <Link to={`/data/types/${documentType.id}`}>
          {documentType.name}
        </Link>
      </TableCell>
      <TableCell sx={{p: 1}}>
        {documentType.type}
      </TableCell>
      <TableCell sx={{p: 1}} align="right">
        {documentType.timesUsed}
      </TableCell>
      <TableCell sx={{p: 1, overflow: 'scroll'}} align="right">
        <Link to={`/data/new/${documentType.id}`}>
          <AddCircleIcon />
        </Link>
      </TableCell>
    </TableRow>
  </>
}

